import { handleActions } from 'redux-actions'
import {
  createGoal,
  createGoalFail,
  createGoalSuccess,
  updateGoal,
  updateGoalFail,
  updateGoalSuccess,
  resetSubmitInProgress,
} from './ChallengeAdminActions'

class State {
  // Tracks create/edit submission so buttons can show loader and disable.
  submitInProgress: boolean = false
}

export const challengeAdmin = handleActions<State, any>(
  {
    [String(createGoal)]: (state: State): State => ({
      ...state,
      submitInProgress: true,
    }),
    [String(createGoalSuccess)]: (state: State): State => ({
      ...state,
      submitInProgress: false,
    }),
    [String(createGoalFail)]: (state: State): State => ({
      ...state,
      submitInProgress: false,
    }),
    [String(updateGoal)]: (state: State): State => ({
      ...state,
      submitInProgress: true,
    }),
    [String(updateGoalSuccess)]: (state: State): State => ({
      ...state,
      submitInProgress: false,
    }),
    [String(updateGoalFail)]: (state: State): State => ({
      ...state,
      submitInProgress: false,
    }),
    [String(resetSubmitInProgress)]: (state: State): State => ({
      ...state,
      submitInProgress: false,
    }),
  },
  new State(),
)

export { State as ChallengeAdminState }
